var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { TestModal } from '../TestModal';
const ModalPortal = ({ role, isOpen, type = 'upload', onSubmit = () => { }, onPrintPDF = () => { }, onFileSelected = () => { }, images = [], onClose = () => { }, resultStatus, consultation, onVerify = () => __awaiter(void 0, void 0, void 0, function* () { }), onDecline = (reason) => __awaiter(void 0, void 0, void 0, function* () { }), attachment, showButtons, }) => {
    if (!isOpen)
        return null;
    return createPortal(_jsx(TestModal, { role: role, type: type, onSubmit: onSubmit, onPrintPDF: onPrintPDF, onClose: onClose, images: images, resultStatus: resultStatus, onFileSelected: onFileSelected, consultation: consultation, onVerify: onVerify, onDecline: onDecline, attachment: attachment, showButtons: showButtons }), document.body);
};
export const useResultModal = () => {
    const role = $auth.role.role;
    const [modalState, setModalState] = useState({
        isOpen: false,
        role,
    });
    const show = useCallback((params) => {
        setModalState(Object.assign(Object.assign({}, params), { isOpen: true, onClose: () => {
                var _a;
                setModalState((prev) => (Object.assign(Object.assign({}, prev), { isOpen: false })));
                (_a = params.onClose) === null || _a === void 0 ? void 0 : _a.call(params);
            } }));
    }, []);
    const hide = useCallback(() => {
        setModalState((prev) => (Object.assign(Object.assign({}, prev), { isOpen: false })));
    }, []);
    const Modal = useCallback(() => {
        return _jsx(ModalPortal, Object.assign({}, modalState));
    }, [modalState]);
    return {
        show,
        hide,
        Modal,
    };
};
